import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { FileText, Search } from "lucide-react";

const FOLDERS = ["Guies", "Circulars", "Formularis", "Convenis", "Descomptes", "General"];

export default function AssocServices() {
  const [docs, setDocs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/documents").then(({ data }) => setDocs(data)); }, []);

  const filtered = docs.filter(d => !q || d.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6" data-testid="assoc-services">
      <div>
        <div className="overline text-accent">Recursos</div>
        <h1 className="mt-2 text-3xl font-heading font-bold tracking-tight">Serveis generals</h1>
        <p className="text-muted-foreground mt-2">Guies, circulars, formularis, convenis i tota la informació útil.</p>
      </div>

      <div className="relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Cerca documents..." value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 rounded-full" data-testid="services-search-input" />
      </div>

      {FOLDERS.map((f) => {
        const items = filtered.filter(d => d.folder === f);
        if (items.length === 0) return null;
        return (
          <div key={f}>
            <div className="text-sm font-heading font-semibold uppercase tracking-widest text-muted-foreground mb-3">{f}</div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {items.map(d => (
                <a key={d.id} href={d.file_url} target="_blank" rel="noreferrer" data-testid={`assoc-doc-${d.id}`}>
                  <Card className="rounded-2xl border-2 hover:border-accent transition-colors duration-200">
                    <CardContent className="p-5 flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center"><FileText className="w-5 h-5" /></div>
                      <div className="min-w-0">
                        <div className="font-medium truncate">{d.name}</div>
                        <div className="text-xs text-muted-foreground uppercase">{d.file_type}</div>
                        {d.description && <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{d.description}</div>}
                      </div>
                    </CardContent>
                  </Card>
                </a>
              ))}
            </div>
          </div>
        );
      })}
      {filtered.length === 0 && <div className="text-muted-foreground text-sm">Sense documents disponibles.</div>}
    </div>
  );
}
